module.exports = __webpack_public_path__ + "static/media/04.091.0c1c3d97.jpg";